module.exports = __webpack_public_path__ + "img/7-ong.2bbac3a6.png";